import { apiService } from 'adapters/apiService';
import { METHOD, PATHS } from 'adapters/constants';
import { HeaderData } from 'adapters/types';
import { validateCompanyAndStore } from 'adapters/utils';
import { PrinterAndCheckNoResponseType } from 'pages/VendorsTablePage/components/PrintChecks/CheckSequence/types';

export const fetchPrintersWithCheckNo = async (
  headers: HeaderData,
  companyId: string,
  storeId: string,
  cashInBank: string
): Promise<PrinterAndCheckNoResponseType[]> => {
  validateCompanyAndStore(companyId, storeId);
  const response = await apiService({
    url: PATHS.getPrintersWithCheckNoPath(cashInBank),
    method: METHOD.GET,
    headers: { ...headers, 'x-store-id': storeId }
  });
  if (response?.ok)
    return response.json() as Promise<PrinterAndCheckNoResponseType[]>;
  throw new Error(response.statusText);
};
